import { iconNameForHeading, isCategoryIconName, normaliseHeading, type CategoryIconName } from './category-icon'

/**
 * The icon a daily-menu section draws — the second half of `FRONTEND.md` §9.91.
 *
 * The owner: *"we have in categories like ikonka kategórie, edit this, **so this icon will be visible
 * in obedové menu**."*
 *
 * **It reads the heading, not the section type**, and the owner's own menu is why. Their `pizza`
 * section is labelled *Burger* and holds burgers — *Sweet Bro, domáca žemľa, 130g hovädzie mäso* —
 * while the `burger` section is labelled *PIZZA* and holds pizzas. The two slots were repurposed and
 * relabelled to match, so the menu a customer reads is correct and only the internal names are stale.
 * An icon taken from the type would have drawn a pizza beside the word *Burger*: worse than the single
 * glyph every section shared before, because it contradicts the word next to it rather than saying
 * nothing.
 *
 * So nothing here can disagree with the heading: the icon is chosen **by the heading**, and a heading
 * that names nothing recognisable draws the crossed forks it drew already.
 */
export function lunchSectionIconName(
  label: string | null | undefined,
  categories: readonly { name?: string | null; icon?: string | null }[] = [],
): CategoryIconName {
  const heading = normaliseHeading(label)
  if (heading === '') return 'other'

  // 1. The franchise's own choice, where a category is named as the section is headed. This is the
  //    owner's ask: pick an icon for Dezerty and the daily menu's dessert heading follows.
  const row = categories.find((category) => normaliseHeading(category.name) === heading)
  const chosen = (row?.icon ?? '').trim()
  if (isCategoryIconName(chosen)) return chosen

  // 2. Otherwise the word itself. `Burgre` and `Burger`, `Šaláty` and `Salaty` are the same heading.
  return iconNameForHeading(label) ?? 'other'
}
